import {
  GetHandshakeCategoryTspropertyListQuery,
  GetHandshakeCategoryTspropertyListQueryVariables,
  GetParentPcListQuery,
  GetParentPcListQueryVariables,
  GetParentPcListWithDetailsQuery,
  GetParentPcListWithDetailsQueryVariables,
  GetpcListWithSeatingPlanDataQuery,
  GetpcListWithSeatingPlanDataQueryVariables,
} from "@/types/gql/generated/graphql";
import { apolloClient } from "@/utils/graphql-client";
import {
  GET_HandshakeCategoryTspropertyList,
  GET_ParentPSCs,
  GET_ParentPSCsWithDetails,
  GET_PCListWithSeatingPlanData,
} from "./queries/product-category.graphql";

export async function getPCListWithSeatingPlanData(categoriesIds: number[]) {
  const variables: GetpcListWithSeatingPlanDataQueryVariables = {
    categories: `(id,in,${categoriesIds.join(",")})`,
  };

  const res = await apolloClient.query<
    GetpcListWithSeatingPlanDataQuery,
    GetpcListWithSeatingPlanDataQueryVariables
  >({
    query: GET_PCListWithSeatingPlanData,
    variables,
  });

  return res.data;
}

/**
 * Pulls parent PSCs from remote using subCategoriesIds.parentPSCId
 * We don't pull all parent PSC fields, we only pull what is needed for Seating Plan logic
 */
export async function pullParentPSCs(parentPSCIds: number[]) {
  const variables: GetParentPcListQueryVariables = {
    categories: `(id,in,${parentPSCIds.join(",")})`,
  };

  const res = await apolloClient.query<
    GetParentPcListQuery,
    GetParentPcListQueryVariables
  >({
    query: GET_ParentPSCs,
    variables,
  });

  return res.data;
}

/**
 * Pulls parent PSCs from remote using subCategoriesIds.parentPSCId
 * Pulls parent PSCs from remote with full details
 */
export async function pullParentPSCsWithDetails(parentPSCIds: number[]) {
  const variables: GetParentPcListQueryVariables = {
    categories: `(id,in,${parentPSCIds.join(",")})`,
  };

  const res = await apolloClient.query<
    GetParentPcListWithDetailsQuery,
    GetParentPcListWithDetailsQueryVariables
  >({
    query: GET_ParentPSCsWithDetails,
    variables,
  });

  return res.data;
}

export async function getHandshakeCategoryTspropertyList(
  categoriesIds: number[]
) {
  const condition = `(category_id,in,${categoriesIds.join(",")})`;
  const res = await apolloClient.query<
    GetHandshakeCategoryTspropertyListQuery,
    GetHandshakeCategoryTspropertyListQueryVariables
  >({
    query: GET_HandshakeCategoryTspropertyList,
    variables: { condition },
  });

  return res.data.HandshakeCategoryTspropertyList || [];
}
